import { queryOptions } from "@tanstack/react-query";
import { getFavoriteArticles, getFavoriteWorkshops, getUserProfileData, getSubscriptionCourse } from "./api";
import type { CourseKey } from "./api.types";

export const getFavoriteArticlesOptions = queryOptions({
	queryKey: ["favorite-articles"],
	queryFn: () => getFavoriteArticles(),
});

export const getFavoriteWorkshopsOptions = queryOptions({
	queryKey: ["favorite-workshops"],
	queryFn: () => getFavoriteWorkshops(),
});

export const getProfileOptions = queryOptions({
	queryKey: ["profile"],
	queryFn: () => getUserProfileData(),
});

export const getSubscriptionCourseOptions = (courseKey: CourseKey) => queryOptions({
	queryKey: ["subscriptionCourse", courseKey],
	queryFn: () => getSubscriptionCourse(courseKey),
});
